// extracted by mini-css-extract-plugin
module.exports = {"container":"SpeedLimitModal_container__CijLS","close":"SpeedLimitModal_close__2ogxm","title":"SpeedLimitModal_title__RW_Pq","description":"SpeedLimitModal_description__1wpI3"};